<template>
  <svg class="icon icon--back" width="60px" height="64px" viewBox="0 0 60 64" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g class="04_05_VIRTUAL" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-426.000000, -482.000000)">
      <g class="Back" transform="translate(427.000000, 483.000000)">
        <polyline class="Path-6" stroke="#FFFFFF" stroke-width="2" points="39.9948243 0.319292917 0.690342641 0.319292917 0.690342641 61.1445455 39.9948243 61.1445455"></polyline>
        <g class="BACK" transform="translate(14.000000, 10.000000)">
          <polygon class="back-button" fill="#FFFFFF" fill-rule="nonzero" points="1.07522765 19.681877 0 20.7520782 1.07522765 21.8222794 20.3430205 41 21.724332 39.372183 2.20208487 20.2361291 2.20208487 21.8222794 22.2103456 1.58168387 20.8495447 0"></polygon>
          <path d="M2,21 L45,21" class="Path-3" stroke="#FFFFFF" stroke-width="2"></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default{
    data(){
      return {}
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/icons/Back.vue